import AskQuestion from './AskQuestion';
export default AskQuestion;